export const userConstants = {
    USER_ROUTES: {
        BLOCK_USER: '/users/block-status/',
    },
    PROFILE_REQUEST: 'USERS_PROFILE_REQUEST',
    PROFILE_FAILURE: 'USERS_PROFILE_FAILURE',
    PROFILE_SUCCESS: 'USERS_PROFILE_SUCCESS',
};
